import styles from "./ColumnResizer.module.css";

/**
 * Компонент добавляет столбцу перетаскиваемую границу,
 * которая позволяет изменять его ширину
 * @param {object} props
 * @param {function} props.mouseDownHandler - обработчик onMouseDown
 */
export const ColumnResizer = ({ mouseDownHandler }) => {
	return <div className={styles.resizer} onMouseDown={mouseDownHandler}></div>;
};
